import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IonicTimepickerService {

  isModalOpen = false;

  constructor() { }
}
